import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from 'prop-types';
import React from 'react';
import classNames from '@jd/jmtd-tools/es/classnames';
import FormItemLabel from '../FormItemLabel';
import ConfigConsumerProvider from '../ConfigConsumerProvider';
import FormContext from '../tools/FormContext';
import { isEmpty } from '../tools/util';
export default function FormItem(_ref) {
  var className = _ref.className,
      label = _ref.label,
      children = _ref.children,
      size = _ref.size,
      inline = _ref.inline,
      bordered = _ref.bordered,
      separator = _ref.separator,
      status = _ref.status,
      description = _ref.description,
      vertical = _ref.vertical,
      required = _ref.required,
      trackComponentName = _ref['data-component-name'];
  return /*#__PURE__*/React.createElement(ConfigConsumerProvider, {
    context: FormContext,
    inline: inline,
    bordered: bordered,
    separator: separator,
    vertical: vertical
  }, function (_ref2) {
    var configBordered = _ref2.bordered,
        configInline = _ref2.inline,
        configSeparator = _ref2.separator,
        configVertical = _ref2.vertical,
        formItemClassName = _ref2.formItemClassName,
        itemMargin = _ref2.itemMargin;
    return /*#__PURE__*/React.createElement(ConfigConsumerProvider, {
      size: size
    }, function (_ref3) {
      var configSize = _ref3.size;
      return /*#__PURE__*/React.createElement("div", {
        "data-component-name": trackComponentName,
        "data-event-label-selector": ".jmtd-form-item-label",
        style: inline ? {
          marginRight: itemMargin
        } : {
          marginBottom: itemMargin
        },
        className: classNames('jmtd-form-item', className, formItemClassName, _defineProperty({
          'jmtd-form-item-no-content': isEmpty(children),
          'jmtd-form-item-no-label': !label,
          'jmtd-form-item-with-label': label,
          'jmtd-form-item-with-separator': configSeparator,
          'jmtd-form-item-large': configSize === 'large',
          'jmtd-form-item-small': configSize === 'small',
          'jmtd-form-item-mini': configSize === 'mini',
          'jmtd-form-item-inline': configInline,
          'jmtd-form-item-bordered': configBordered,
          'jmtd-form-item-vertical': configVertical
        }, "jmtd-form-item-".concat(status), status))
      }, (label || required) && /*#__PURE__*/React.createElement(FormItemLabel, {
        required: required
      }, label), configSeparator && label && /*#__PURE__*/React.createElement("div", {
        className: "jmtd-form-item-separator"
      }), /*#__PURE__*/React.createElement("div", {
        className: "jmtd-form-item-content"
      }, children, description && /*#__PURE__*/React.createElement("div", {
        className: "jmtd-form-item-description"
      }, description)));
    });
  });
}
FormItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(['large', 'middle', 'small', 'mini']),
  label: PropTypes.node,
  bordered: PropTypes.bool,
  inline: PropTypes.bool,
  separator: PropTypes.bool,
  status: PropTypes.oneOf(['info', 'success', 'warning', 'danger']),
  description: PropTypes.node,
  required: PropTypes.bool,
  vertical: PropTypes.bool,
  'data-component-name': PropTypes.string
};
FormItem.defaultProps = {
  children: null,
  className: '',
  size: null,
  label: null,
  bordered: null,
  inline: null,
  separator: null,
  status: null,
  description: null,
  vertical: null,
  required: false,
  'data-component-name': ''
};